var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site",attrs:{"id":"site"}},[_c('LazyHydrate',{attrs:{"when-idle":""}},[_c('AnimateBodyBackground')],1),_vm._v(" "),_c('Nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }